import { useCallback } from 'react';
import { toast } from 'react-toastify';

import { useSpdCore } from './useSpdCore';

export const useSaveFileInBrowser = () => {
  const spd = useSpdCore();

  return useCallback(
    (id: string, name: string, method: 'open' | 'download'): void => {
      void spd.attachments.saveFileInBrowser(id, name, method).catch(() => {
        toast.error('Wystąpił problem z pobraniem załącznika.');
      });
    },
    [spd],
  );
};
